import { UiMessage } from 'models/UiMessageModel';

export const UiMessageActionType = {
    CLEAR: 'CLEAR',
    SHOW: 'SHOW',
};

interface IShowUiMessageAction {
    type: typeof UiMessageActionType.SHOW,
    messageData: UiMessage[]
}

interface IClearUiMessageAction {
    type: typeof UiMessageActionType.CLEAR,
    messageData: UiMessage[] | null
}

export type UiMessageActions = IShowUiMessageAction | IClearUiMessageAction

export function showMessage(uiMessagedata: UiMessage[]): UiMessageActions {
    return {
        type: UiMessageActionType.SHOW,
        messageData: uiMessagedata
    }
}

export function clearUiMessage(): UiMessageActions {
    return {
        type: UiMessageActionType.CLEAR,
        messageData: null
    }
}

